<template>
  <div>
    <div id="root">
      <div
        class="row bg-primary text-light align-items-center text-center"
        style="height: 70px;"
      >
        <div class="col">
          <span class="logo-sm">
            <span v-if="userData.logo != 0">
              <img
                :src="getFiles(userData.logo)"
                height="50"
                style="border-radius: 60px;"
              />
            </span>
            <span v-else>
              <img
                src="@/assets/images/logo.png"
                height="40"
                style="border-radius: 50px;"
              />
            </span>
          </span>
        </div>
        <div class="col">Select SACCO Branch</div>
        <div class="col">
          <div class="d-flex justify-content-center align-self-center">
            <b-dropdown
              right
              variant="black"
              toggle-class="header-item"
              menu-class="dropdown-menu-end"
            >
              <template v-slot:button-content>
                <i class="mdi mdi-account-circle mdi-24px text-light"></i>
                <span class="d-none d-xl-inline-block mt-n2 ms-1 text-light">
                  {{ userData.username }}
                </span>
                <i
                  class="mdi mdi-chevron-down d-none d-xl-inline-block text-light"
                ></i>
              </template>
              <a href="/logout" class="dropdown-item text-danger">
                <i
                  class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
                ></i>
                Logout
              </a>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <img src="@/assets/images/save.jpg" width="100%" />
    </div>
    <b-modal
      id="edit-member"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      size="md"
      centered
      hide-header
      hide-footer
    >
      <div class="text-center fw-bold fs-4">Select Branch</div>
      <hr />
      <div v-for="(branch, index) in branches" :key="index">
        <div class="d-flex fs-5">
          {{ index + 1 }}. &nbsp;<a
            @click.prevent="getBranch(branch.branch.id)"
            class="d-flex"
            href=""
            ><div class="mx-1">{{ branch.branch.name }}</div>
            |
            <div class="mx-1">{{ branch.branch.location }}</div></a
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Layout from "../../layouts/main";
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      branches: JSON.parse(localStorage.getItem("branches")),
      title: "Applicants",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Members", active: true },
      ],
      id: "",
    };
  },

  methods: {
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },

    chooseBranch() {
      this.$bvModal.show("edit-member");
    },

    async getBranch(id) {
      const obj = {
        branch_id: id,
      };
      let url = "active_branch";
      await axios.post(url, obj);
      this.$router.push("/");
    },
  },

  mounted() {
    this.chooseBranch();
  },
};
</script>

<style>
.background {
  background-position: center;
  background-size: cover;
}

.content {
  position: absolute;
}
</style>
